<template>
  <menu :class="{visible}">
    <v-icon size="32" @click="emit('close')">las la-times</v-icon>

    <div class="menu__items">
      <ul>
        <li v-for="item of items">
          <a :href="item.href" v-text="item.label" />
        </li>
      </ul>
    </div>

  </menu>
</template>

<script setup lang="ts">
const emit = defineEmits(['close'])

const visible: Ref<Boolean> = ref(false)

const { items } = defineProps<{
  items: IPage[]
}>()

onMounted(() => {
  setTimeout(() => {
    visible.value = true
  }, 250)
})
</script>

<style scoped lang="scss">
menu {
  z-index: 2;
  opacity: 0;
  transition: all 0.5s ease-in-out;

  > div {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    transform: translateY(-50%);
    line-height: 48px;
    padding: 0 30px;
    font-size: 28px;
    text-transform: uppercase;
  }

  .v-icon {
    position: fixed;
    top: 33px;
    right: 24px;
    cursor: pointer;
    color: rgb(var(--v-theme-primary));
  }

  &.visible {
    opacity: 1;
  }

  ul {
    list-style-type: none;

    li {
      transition: opacity 0.15s ease-in-out;
      opacity: 1;

      &:hover {
        opacity: 0.65;
      }

      a {
        text-decoration: none;
      }
    }
  }
}
</style>